export default function Menu() {
  const menuCategories = [
    {
      name: 'Signature Cocktails',
      image: 'https://public.readdy.ai/ai/img_res/a17fe0ece3cf17c156c3bef5270b0710.jpg',
      color: 'bg-gradient-to-br from-pink-100 to-pink-200'
    },
    {
      name: 'Korean Bites',
      image: 'https://readdy.ai/api/search-image?query=delicious%20korean%20appetizers%20and%20snacks%20on%20white%20plates%20fried%20chicken%20wings%20kimchi%20dumplings%20and%20spring%20rolls%20beautifully%20plated%20asian%20fusion%20food%20with%20dipping%20sauces%20restaurant%20quality%20presentation%20with%20garnishes%20warm%20lighting%20on%20wooden%20table&width=600&height=800&seq=menu-korean-food&orientation=portrait',
      color: 'bg-gradient-to-br from-green-100 to-green-200'
    },
    {
      name: 'Beer &amp; Soju',
      image: 'https://readdy.ai/api/search-image?query=assorted%20beer%20bottles%20and%20soju%20bottles%20on%20ice%20korean%20alcoholic%20beverages%20with%20shot%20glasses%20craft%20beer%20selection%20with%20condensation%20on%20bottles%20bar%20display%20with%20ambient%20lighting%20premium%20drink%20selection%20in%20nightclub%20setting&width=600&height=800&seq=menu-beer-soju&orientation=portrait',
      color: 'bg-gradient-to-br from-purple-100 to-purple-200'
    },
    {
      name: 'Desserts',
      image: 'https://readdy.ai/api/search-image?query=elegant%20desserts%20and%20sweet%20treats%20on%20white%20plates%20colorful%20cakes%20and%20pastries%20with%20fresh%20berries%20korean%20inspired%20sweets%20with%20artistic%20presentation%20cafe%20style%20dessert%20plating%20with%20whipped%20cream%20and%20chocolate%20drizzle%20soft%20natural%20lighting&width=600&height=800&seq=menu-desserts&orientation=portrait',
      color: 'bg-gradient-to-br from-orange-100 to-orange-200'
    }
  ];

  return (
    <section id="menu" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-music-note-line text-pink-600 text-xl"></i>
            <span className="text-pink-600 text-sm font-semibold tracking-wider uppercase">Our Menu</span>
          </div>
          <h2 className="text-6xl md:text-7xl font-bold text-gray-900 leading-tight">
            Drinks &amp;<br />
            <span className="italic font-light">Bites</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {menuCategories.map((category, index) => (
            <div
              key={index}
              className="group cursor-pointer hover:scale-105 transition-all duration-300"
            >
              <div className="rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                <div className="relative h-96 w-full">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className={`${category.color} p-6`}>
                  <h3 className="text-xl font-bold text-gray-900 text-center">{category.name}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Full menu available at the venue. Ask our staff about daily specials and happy hour deals!
          </p>
          <button className="bg-pink-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-pink-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap">
            View Full Menu
          </button>
        </div>
      </div>
    </section>
  );
}
